import { trackEvent } from '@/lib/analytics'

const LogosSection = () => {
  return (
    <section className="relative w-full bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0f1a] to-black"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-16 md:pb-24">
        {/* Row 1: three logos */}
        <div className="grid grid-cols-3 gap-8 md:gap-12 items-center justify-items-center mb-10">
          <img
            src="/spoke-static/images/SPOKE_filmabee_studios_logo_transparent.png"
            alt="Filmabee Studios"
            className="h-28 md:h-36 w-auto object-contain transition-transform duration-200 hover:scale-110 cursor-pointer"
          />
          <img
            src="/spoke-static/images/SPOKE_renton_fire_authority_logo.png"
            alt="Renton Regional Fire Authority"
            className="h-20 md:h-24 w-auto object-contain transition-transform duration-200 hover:scale-110 cursor-pointer"
          />
          <img
            src="/spoke-static/images/crackyl-logo.png"
            alt="Crackyl — Firefighter Lifestyle & Health"
            className="h-10 md:h-12 w-auto object-contain transition-transform duration-200 hover:scale-110 cursor-pointer"
          />
        </div>

        {/* Row 2: FRCE + Tersus + Local 1747 */}
        <div className="grid grid-cols-3 gap-8 md:gap-12 items-center justify-items-center">
          <div className="bg-white rounded-xl p-3 flex items-center justify-center transition-transform duration-200 hover:scale-110 cursor-pointer">
            <img
              src="/spoke-static/images/SPOKE_frce_logo.jpg"
              alt="First Responder Center for Excellence"
              className="h-24 md:h-28 w-auto object-contain"
            />
          </div>
          <img
            src="/spoke-static/images/tersus-logo.png"
            alt="Tersus"
            className="h-12 md:h-16 w-auto object-contain transition-transform duration-200 hover:scale-110 cursor-pointer"
          />
          <img
            src="/spoke-static/images/local-1747-logo-nobg.png"
            alt="Local 1747 Puget Sound Firefighters"
            className="h-28 md:h-32 w-auto object-contain transition-transform duration-200 hover:scale-110 cursor-pointer"
          />
        </div>

        <div className="mt-12 text-center">
          {/* Deputy Chief Ron Mondragon quote */}
          <div className="max-w-3xl mx-auto text-left">
            <div className="space-y-4 text-gray-300 font-poppins text-base sm:text-lg leading-relaxed font-light italic">
              <p>"Had to let Spoke sink in a bit. Probably due to how much I can relate to the CISM/PTSD causes and effects after 43 years of service.</p>
              <p>Bravo on your ability to learn, organize and effectively communicate such a complex message to your audience. Typically firefighters do not share outside of their peers, yet you were able to take a glimpse inside of this honorable culture and place it on film for all to see. I believe this subject matter is something everyone can relate to on some level through personal experiences.</p>
              <p>Bravo! Bravo!"</p>
            </div>
            <p className="mt-4 text-yellow-400 font-poppins font-semibold text-sm tracking-widest uppercase">— Deputy Chief Ron Mondragon</p>
            <p className="text-gray-500 font-poppins text-sm mt-1">Seattle Fire Department, Retired</p>
          </div>

          <p className="mt-12 text-white font-montserrat font-black uppercase tracking-wide text-3xl md:text-5xl leading-tight">
            Help SPOKE show in your city!
          </p>

          <div className="mt-10">
            <a
              href="https://filmabee-studios.kit.com/spoke"
              onClick={() => trackEvent('newsletter_click', { site: 'spoke', film: 'spoke', placement: 'logos', provider: 'kit' })}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-red-600 hover:bg-red-700 transition-colors duration-300 px-8 py-4 rounded-lg cursor-pointer"
            >
              <span className="text-yellow-400 font-montserrat font-black uppercase tracking-wide text-xl md:text-2xl">
                Let us know where you are. Sign up.
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LogosSection
